const init = () => {
    const horizontalStepsListBlocks = document.querySelectorAll('.horizontal-steps-list__wrap');
    if (!horizontalStepsListBlocks.length) {
        return;
    }

    horizontalStepsListBlocks.forEach(currentBlock => {
        const currentSteps = currentBlock.querySelectorAll('.horizontal-steps-list__step');
        const navigationButtons = currentBlock.querySelectorAll('.horizontal-steps-list__nav-list-item button');

        showInitialStep(currentSteps);
        setInitialActiveNavLink(navigationButtons);
        handleNavLinks(navigationButtons, currentBlock);
    });

    function showInitialStep(steps) {
        steps[0].classList.remove('horizontal-steps-list__step--hidden');
    }

    function setInitialActiveNavLink(navLinks) {
        if (navLinks.length) {
            navLinks[0].classList.add('horizontal-steps-list__nav-list-item-button--active');
        }
    }

    function handleNavLinks(navLinks, block) {
        navLinks.forEach(navLink => {
            navLink.addEventListener('click', () => {
                highlightCurrentNavLink(navLinks, navLink);
                showCurrentStep(navLink, block);
            });
        });
    }

    function highlightCurrentNavLink(navLinks, currentLink) {
        navLinks.forEach(navLink => {
            navLink.classList.remove('horizontal-steps-list__nav-list-item-button--active');
        });
        currentLink.classList.add('horizontal-steps-list__nav-list-item-button--active');
        scrollToElement(currentLink);
    }

    function showCurrentStep(link, block) {
        const steps = block.querySelectorAll('.horizontal-steps-list__step');
        const linkId = link.id.split('-')[1];

        steps.forEach(step => {
            const isCurrentStep = linkId === step.id.split('-')[1];
            const children = Array.from(step.children);

            setTimeout(() => {
                children.forEach(c => {
                    if (isCurrentStep) {
                        c.classList.add('horizontal-steps-list__step--fade-in');
                        step.classList.remove('horizontal-steps-list__step--hidden');
                    } else {
                        c.classList.remove('horizontal-steps-list__step--fade-in');
                        step.classList.add('horizontal-steps-list__step--hidden');
                    }
                });
            }, 75);
        });
    }

    function scrollToElement(el) {
        const elLeft = el.offsetLeft + el.offsetWidth + 50;
        const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;

        if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
            let goal = elLeft - elParentLeft;
            for (let i = 0; i <= goal; i++) {
                setTimeout(() => {
                    el.parentNode.scrollLeft = i;
                }, 0);
            }
        } else {
            el.parentNode.scrollLeft = (el.offsetLeft - el.parentNode.offsetLeft) - 50;
        }
    }
};

document.addEventListener('DOMContentLoaded', init);
